module.exports = __webpack_public_path__ + "img/public_safety_icon.b114901b.png";